import { useReducer } from 'react';

type State<TItem> = {
	addToCache: TItem[];
	removeFromCache: TItem[];
	handleFilteredUpdate: number[];
};

type Action<TItem> =
	| {
			type: 'ADD_TO_CACHE';
			issues: TItem[];
	  }
	| {
			type: 'REMOVE_FROM_CACHE';
			issues: TItem[];
	  }
	| {
			type: 'HANDLE_FILTERED_UPDATE';
			issues: number[];
	  }
	| {
			type: 'CLEAR';
	  };

// react's Dispatch type isn't exported
type Dispatch<TItem> = (action: Action<TItem>) => void;

const cacheActionsReducer = <TItem,>(state: State<TItem>, action: Action<TItem>): State<TItem> => {
	switch (action.type) {
		case 'ADD_TO_CACHE':
			return {
				...state,
				addToCache: [...state.addToCache, ...action.issues],
			};
		case 'REMOVE_FROM_CACHE':
			return {
				...state,
				removeFromCache: [...state.removeFromCache, ...action.issues],
			};
		case 'HANDLE_FILTERED_UPDATE':
			return {
				...state,
				handleFilteredUpdate: [...state.handleFilteredUpdate, ...action.issues],
			};
		case 'CLEAR': {
			return {
				addToCache: [],
				removeFromCache: [],
				handleFilteredUpdate: [],
			};
		}
		default:
			return state;
	}
};

export const useCacheActionsReducer = <TItem,>(): [State<TItem>, Dispatch<TItem>] =>
	// @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
	useReducer<State<TItem>, Action<TItem>>(cacheActionsReducer, {
		addToCache: [],
		removeFromCache: [],
		handleFilteredUpdate: [],
	});
